import React from 'react';
import axios from 'axios';
import FontAwesome from 'react-fontawesome';
import {Button, Modal, OverlayTrigger, Tooltip} from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";

import Table from "../../components/Table/index";

class SpecialList extends React.Component{
    constructor(props) {
        super(props);

        const tooltipPreview = (
            <Tooltip id="tooltip-preview">Zobrazit</Tooltip>
        );
        const tooltipImage = (
            <Tooltip id="tooltip-image">Přidat/upravit obrázek</Tooltip>
        );
        const tooltipVideos = (
            <Tooltip id="tooltip-videos">Správa videí</Tooltip>
        );
        const tooltipEnable = (
            <Tooltip id="tooltip-enable">Zakázat speciál</Tooltip>
        );
        const tooltipDisable = (
            <Tooltip id="tooltip-disable">Povolit speciál</Tooltip>
        );
        const tooltipEdit = (
            <Tooltip id="tooltip-edit">Upravit</Tooltip>
        );
        const tooltipRemove = (
            <Tooltip id="tooltip-remove">Odstranit</Tooltip>
        );

        const columns = [
            {
                Header: 'Název',
                accessor: 'name'
            },
            {
                Header: 'Hodnota v bodech',
                accessor: 'pointsValue'
            },
            {
                Header: 'Hodnota v penězích',
                accessor: 'moneyValue'
            },
            {
                Header: 'Možnosti',
                style: {padding: '0px'},
                filterable: false,
                sortable: false,
                Cell: row => (
                    <div className="row-menu">
                        <OverlayTrigger placement="top" overlay={tooltipPreview}>
                            <Link to={`/specials/preview/${row.original.id}`}>
                                <FontAwesome
                                  name="eye"
                                  className="cursor-p"
                                />
                            </Link>
                        </OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={tooltipImage}>
                            <Link to={`/specials/image/${row.original.id}`}>
                                <FontAwesome name="picture-o" className="cursor-p" />
                            </Link>
                        </OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={tooltipVideos}>
                            <Link to={`/specials/video/${row.original.id}`}>
                                <FontAwesome name="video-camera" className="cursor-p" />
                            </Link>
                        </OverlayTrigger>
                        {
                            row.original.enabled &&
                            <OverlayTrigger placement="top" overlay={tooltipEnable}>
                                <FontAwesome name="unlock" onClick={() => this.props.handleChangeEnabled(row.original)}
                                             className="cursor-p"/>
                            </OverlayTrigger>
                        }
                        {
                            !row.original.enabled &&
                            <OverlayTrigger placement="top" overlay={tooltipDisable}>
                                <FontAwesome name="lock" onClick={() => this.props.handleChangeEnabled(row.original)}
                                             className="cursor-p"/>
                            </OverlayTrigger>
                        }
                        <OverlayTrigger placement="top" overlay={tooltipEdit}>
                            <Link to={`/specials/edit/${row.original.id}`}>
                                <FontAwesome
                                  name="pencil-square-o"
                                  className="cursor-p"
                                />
                            </Link>
                        </OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={tooltipRemove}>
                            <FontAwesome name="trash" onClick={() => this.showModal(row.original)}
                                         className="cursor-p"/>
                        </OverlayTrigger>
                    </div>
                )
            }
        ];

        const tableOptions = {
            showPagination: true,
            showPageSizeOptions: true,
            showPageJump: true,
            collapseOnSortingChange: true,
            collapseOnPageChange: true,
            collapseOnDataChange: true,
            freezeWhenExpanded: false,
            filterable: true,
            sortable: true,
            resizable: true,
            defaultPageSize: 5,
            defaultSorted: [{
                id: 'name',
                desc: false
            }]
        };

        this.state = {
            specials: [],
            removeSpecial: null,
            columns,
            tableOptions
        };

        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
        this.getSpecials();
    }

    getSpecials() {
      let loginToken = this.props.sessionData.accessToken;
      let config = {
        headers: {
          'Authorization': 'Bearer ' + loginToken
        }
      };
        axios.get(this.props.api.specials, config)
            .then((result) => {
                if (!this._calledComponentWillUnmount) {
                    this.setState({
                        specials: result.data,
                        tableOptions: {
                            ...this.state.tableOptions,
                            loading: false
                        }
                    });
                }
            }).catch(function (error) {
            console.error('Error axios:', error);
        });
    }

    closeModal() {
        this.setState({
            showModal: false,
            removeSpecial: null
        })
    }

    showModal(special) {
        this.setState({
            showModal: true,
            removeSpecial: special
        })
    }

    render() {
        let {specials, removeSpecial} = this.state;
        return (
            <div className="x-panel">
                <div className="x-title">
                    <h2>Seznam speciálů</h2>
                    <Button className="btn-success btn-add" onClick={() => this.props.history.push('/specials/add')}>
                        <FontAwesome name="plus"/>
                    </Button>
                    <div className="clearfix"/>
                </div>
                <div className="x-content">
                    <Table
                        columns={this.state.columns}
                        data={specials}
                        tableOptions={this.state.tableOptions}
                        defaultFilterMethod={(filter, row) => (String(row[filter.id]).includes(filter.value))}
                    />
                </div>
                {
                    removeSpecial &&
                    <Modal show={this.state.showModal} onHide={this.closeModal} backdrop='static'>
                        <Modal.Header closeButton className="text-danger bg-danger">
                            <Modal.Title>Odstranění speciálu</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p>Opravdu chcete odstranit speciál: {removeSpecial.name}?</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={this.closeModal}>Zrušit</Button>
                            <Button className='btn btn-danger' onClick={() => this.props.handleRemoveSpecial(removeSpecial)}>Odstranit</Button>
                        </Modal.Footer>
                    </Modal>
                }
            </div>
        );
    }
}

export default withRouter(SpecialList);



/** WEBPACK FOOTER **
 ** ./src/containers/Specials/SpecialList.js
 **/